import React, { useState, useEffect, useRef } from 'react';
// import { useEditStore } from '../stores';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import ExampleColorPickerView from './exampleColorPickerView';

export function DetailContent(data) {
  const theme = useSelector((state) => state.redTheme);
  console.log('ini single theme', theme);

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  const baseImg =
    'https://cdn.pixabay.com/photo/2017/06/09/07/42/flower-2386049_960_720.jpg';

  const handleImgError = (e) => {
    e.target.src = baseImg;
  };
  return (
    <>
      <Desktop>NAS</Desktop>
    </>
  );
}
